export default function maintenanceMessages(state = [], action) {
  // Maintenance messages are set on initial state from window.__STATE__
  // This reducer doesn't need to handle any actions since messages are server-provided
  return state
}
